<template>
  <iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
    <template #rightContent>
      <div v-if="loading">
        <div class="pl20 pr20 pt20 pb20 content-box bgfff mb20" v-if="edit">
          <div class="c222 f18 border-b pb20 text-left">资质变更</div>
          <div class="c222 f14 pt20 text-left fw600">
            上传说明：
          </div>
          <div class="c777 f14 pt10 text-left">
            1、上传的图片清晰、完整。<br />
            2、录入的证件号与有效期与证件完全一致。<br />
            3、如有变更记录，请上传相关证件的变更记录。<br />
          </div>
        </div>
        <div class="pl20 pr20 pt20 pb20 content-box bgfff mb20" v-if="!edit">
          <van-cell title="门店资质" title-class="c222 f18 text-left" class="border-b pb20 pl0 pr0 pt0"
            value-class="c0F6EEA f14 flex align-items-center justify-content-flex-end cpointer" :border="false" @click.stop="changeEdit">
            <template v-if="FirstOrderStatus != 1">
              <van-image :src="require('@/assets/mine/zizhieidt-icon.png')" width="14px" height="14px" class="mr5" />
              <span class="f14">{{
                !FirstOrderStatus || FirstOrderStatus == 4
                  ? '资质提交'
                  : '资质更新'
              }}</span>
            </template>
          </van-cell>
          <van-cell title="首营资料" :title-class="
              FirstOrderStatus == 3
                ? 'c777 f18 text-left w118 flex-n'
                : 'c222 f18 text-left w118 flex-n'
            " class="pb10 pt30 pl0 pr0" value-class=" f18 text-left fw600" :border="false">
            <template>
              <span :class="
                  !FirstOrderStatus || FirstOrderStatus == 4
                    ? 'cFE6120'
                    : FirstOrderStatus == 1
                    ? 'c0F6EEA'
                    : FirstOrderStatus == 3
                    ? 'cFF3939'
                    : 'c222'
                ">{{
                  !FirstOrderStatus || FirstOrderStatus == 4
                    ? '未提交'
                    : FirstOrderStatus == 1
                    ? '审核中'
                    : FirstOrderStatus == 3
                    ? '审核失败'
                    : '已通过'
                }}</span>
            </template>
          </van-cell>
          <van-cell title="审核意见" title-class="c777 f18 text-left w118 flex-n" class="pb10 pt10 pl0 pr0" value-class="f18 text-left c222"
            :border="false" :value="FirstOrderStatusReason" v-if="FirstOrderStatus == 3" />
          <van-button :color="
              !FirstOrderStatus || FirstOrderStatus == 4
                ? '#0F6EEA'
                : FirstOrderStatus == 1
                ? '#D5D5D5'
                : FirstOrderStatus == 3
                ? '#0F6EEA'
                : '#D5D5D5'
            " :text="
              !FirstOrderStatus || FirstOrderStatus == 4
                ? '去提交'
                : FirstOrderStatus == 1
                ? '审核中'
                : FirstOrderStatus == 3
                ? '重新提交'
                : '已通过'
            " class="mt30 mb10 submitBtn f16 cfff fw600" :disabled="
              FirstOrderStatus && FirstOrderStatus != 4 && FirstOrderStatus != 3
            " @click.stop="edit = true"></van-button>
        </div>
        <div>
          <van-form>
            <div v-if="edit" class="boxshadow pl20 pr20 pt20 bgfff">
              <van-cell :border="false" title-class="text-left c222 f14 fw600" class="pl0 pr0 pt0">
                <template #title>
                  <span class="att_title" />
                  <span style="margin-left:8px;">
                    基本信息
                  </span>
                </template>
              </van-cell>
              <van-row class="mt5">
                <van-col :span="16">
                  <div>
                    <van-field required v-model="CustomerName" placeholder="客户名称" class="input-bo c222 mb20 " label="客户名称"
                      label-class="c777 f12 text-left" maxlength="40" :readonly="false" />
                  </div>
                  <div>
                    <van-field :value="CustomerType == 1? '药店': CustomerType == 2? '诊所': ''" label="客户类型" class="input-bo c222 mb20 "
                      label-class="c777 f12 text-left" maxlength="40" :readonly="true" />
                  </div>
                  <div class="c222 mb20 areas-border" v-if="CustomerType == 2">
                    <div class="c777 f12 text-left areas-border-required">
                      经营性质
                    </div>
                    <van-radio-group v-model="FileDatas.BusinessNature" direction="horizontal" class="mb10" icon-size="14px">
                      <van-radio :name="1">盈利性</van-radio>
                      <van-radio :name="2">非营利性</van-radio>
                    </van-radio-group>
                  </div>
                  <div>
                    <van-field required v-model="BaseDatas.Address" placeholder="注册地址" class="input-bo c222 mb20 " label="注册地址"
                      label-class="c777 f12 text-left" maxlength="40" :readonly="false" />
                  </div>
                  <div class="c222 mb20 areas-border">
                    <div class="c777 f12 text-left areas-border-required">
                      收货地址
                    </div>
                    <CityAreasControl ref="cityAreas" @change="setAreas" />
                  </div>
                  <div>
                    <van-field required v-model="BaseDatas.Receiving.Address" placeholder="详细地址" class="input-bo c222 mb20 " label="详细地址"
                      label-class="c777 f12 text-left" maxlength="40" :readonly="false" />
                  </div>
                  <div>
                    <van-field required v-model="BaseDatas.ContactsName" placeholder="联系人" class="input-bo c222 mb20 " label="联系人"
                      label-class="c777 f12 text-left" maxlength="40" :readonly="false" />
                  </div>
                  <div>
                    <van-field required v-model="BaseDatas.Phone" placeholder="联系电话" class="input-bo c222 mb20 " label="联系电话"
                      label-class="c777 f12 text-left" maxlength="40" :readonly="true" />
                  </div>
                </van-col>
              </van-row>
            </div>
            <template v-for="(item, i) in FileDatas.filter(
                (w) =>
                  w.GroupCode != 'LegalIdentifyReverseSide' &&
                  w.GroupCode != 'ClientIdentifyReverseSide' &&
                  w.GroupCode != 'AuthorityPurchase')">
              <div class="boxshadow pl20 pr20 pt20 bgfff" :key="i"
                v-if="!edit || (edit && (item.GroupCode != 'GSP' || (item.GroupCode == 'GSP' && BaseDatas.IsTwoInOne == false )))">
                <!----------------------------------------------- 证件提示 begin --------------------------------------------->
                <van-cell :title="item.GroupAttrName + '已过期，您目前不能下单！'" title-class="text-left"
                  class="pb10 pt10 pl20 pr20 f14 cFF3939 bgFFECEC mb40" style="cursor: pointer;" :border="false" :value="edit ? '' : '去更新'"
                  value-class="cFF3939" v-if="item.QualificationsExpired && FirstOrderStatus != 1" @click.stop="
                  FirstOrderStatus &&
                  FirstOrderStatus != 4 &&
                  FirstOrderStatus != 3 &&
                  edit? '': (edit = true)" />

                <van-cell :title="item.GroupAttrName + '即将过期，过期后您将不能下单！'" title-class="text-left"
                  class="pb10 pt10 pl20 pr20 f16 cFF3939 bgFFECEC mb40" :border="false" :value="edit ? '' : '去更新'" value-class="cFF3939"
                  v-if="item.QualificationsWarning && FirstOrderStatus != 1" @click.stop="
                  FirstOrderStatus &&
                  FirstOrderStatus != 4 &&
                  FirstOrderStatus != 3 &&
                  edit? '' : (edit = true)" />

                <van-cell title-class="text-left c222 f14 fw600" class="pl0 pr0 pt0" :border="false" value-class="cFF3939"
                  v-if="BaseDatas.LegalIdentifyClientIdentify == 1 ? item.GroupCode == 'LegalIdentify' : BaseDatas.LegalIdentifyClientIdentify == 2 ? item.GroupCode == 'ClientIdentify' :  item.GroupCode == 'LegalIdentify'">
                  <template #title>
                    <span class="att_title" />
                    <span style="margin-left:8px;">
                      采购人员信息
                      <span class="cFF3939">*</span>
                    </span>
                    <div class="fw400 mt10" v-if="edit">
                      <van-radio-group v-model="BaseDatas.LegalIdentifyClientIdentify" class="mb10" icon-size="14px">
                        <van-radio :name="1">法人或负责人<span class="c777">(采购人员姓名<span class="c0F6EEA">在</span>营业执照或药品经营许可证或gsp证书上)</span>
                        </van-radio>
                        <van-radio class="mt10" :name="2">委托人<span class="c777">(采购人员姓名<span
                              class="c0F6EEA">不在</span>营业执照或药品经营许可证或gsp证书上)</span>
                        </van-radio>
                      </van-radio-group>
                    </div>
                  </template>
                </van-cell>

                <!----------------------------------------------- 证件提示 end --------------------------------------------->


                <!----------------------------------------------- 证件信息 begin --------------------------------------------->
                <van-grid :border="false" :column-num="3" class="align-items-top">

                  <van-grid-item
                    v-if="item.GroupCode != 'AuthorityPurchase' && item.GroupCode != 'LegalIdentify' && item.GroupCode != 'ClientIdentify'">
                    <van-cell :border="false" title-class="text-left c222 f14 fw600" class="pl0 pr0 pt0">
                      <template #title>
                        <span class="att_title" />
                        <span style="margin-left:8px;">
                          {{ item.GroupAttrName }}
                          <span class="cFF3939" v-if="
                            (item.GroupCode == 'BusinessLincense' &&
                              CustomerType == 1) ||
                              item.GroupCode == 'MedicinalLincense' ||
                              item.GroupCode == 'OrganLincense'
                          ">*</span>
                        </span>
                      </template>
                    </van-cell>

                    <div v-if="item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrValue || !edit" class="relative"
                      :class="edit ? 'bgmoren' : 'bgmorendisabled'">
                      <van-image width="100%" height="110px" lazy-load fit="cover" radius="2" :src="
                        _getPic(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrValue,true)" @click.stop="() =>
                          handleImgPreview(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url' )[0].AttrValue,0)" v-if="item['CustomerAttrDtos'].filter(
                          (tag) => tag.AttrCode == 'Url' )[0].AttrValue" />
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999" v-else />
                      <van-icon name="clear" size="24px" style="position: absolute;top: -12px;right: -12px;" @click.stop="
                        delImage(item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrId)"
                        v-if="FirstOrderStatus != 1 && edit" />
                    </div>
                    <iFile class="i_radius hidden fx justify-content-center" :class="
                      FirstOrderStatus == 1 ? 'bgmorendisabled' : 'bgmoren'" :readonly="FirstOrderStatus == 1 ? true : false" @change="
                      (f) => onFile(f,item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrId)" v-else>
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999"
                        v-if="FirstOrderStatus == 1" />
                      <van-image style="border:1px dashed #222222;width:99%;height:99%;" :src="
                        require(`../../assets/mine/${
                          item.GroupCode == 'MedicinalLincense'
                            ? 'YPxkz'
                            : item.GroupCode == 'BusinessLincense'
                            ? 'YLJGxkz'
                            : item.GroupCode == 'LegalIdentify' ||
                              item.GroupCode == 'ClientIdentify'
                            ? 'SFZbmzp'
                            : item.GroupCode == 'GSP'
                            ? 'GSPzs'
                            : 'xiangjiaa'
                        }.png`)" v-else />
                    </iFile>
                  </van-grid-item>

                  <van-grid-item v-if="item['CustomerAttrDtos'].findIndex((tag) => tag.AttrCode == 'History') != -1 &&
                      item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Code')[0].AttrValue">
                    <van-cell :border="false" title-class="text-left c222 f14 fw600" class="pl0 pr0 pt0">
                      <template #title>
                        <span class="att_title" />
                        <span style="margin-left:8px;">{{ item.GroupAttrName }}变更记录</span>
                      </template>
                    </van-cell>
                    <div v-if="
                      item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'History')[0].AttrValue || !edit" class="relative"
                      :class="edit ? 'bgmoren' : 'bgmorendisabled'">
                      <van-image width="100%" height="110px" lazy-load fit="cover" radius="2" :src="
                        _getPic(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'History')[0].AttrValue,true)" @click.stop="
                        () =>handleImgPreview(item['CustomerAttrDtos'].filter( (tag) => tag.AttrCode == 'History')[0].AttrValue,0)" v-if="
                        item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'History')[0].AttrValue" />
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999" v-else />
                      <van-icon name="clear" size="24px" style="position: absolute;top: -12px;right: -12px;"
                        v-if="FirstOrderStatus != 1 && edit" @click.stop="
                        delImage(item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'History' )[0].AttrId)" />
                    </div>
                    <iFile class="i_radius hidden fx justify-content-center" :class="
                      FirstOrderStatus == 1 ? 'bgmorendisabled' : 'bgmoren'
                    " :readonly="FirstOrderStatus == 1 ? true : false" @change="(f) =>onFile(f,item.GroupAttrId,item['CustomerAttrDtos'].filter(
                            (tag) => tag.AttrCode == 'History')[0].AttrId)" v-else>
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999"
                        v-if="FirstOrderStatus == 1" />
                      <!-- <van-icon :name="require('../../assets/mine/xiangjiaa.png')" size="40px" color="#999" v-else /> -->
                      <van-image style="border:1px dashed #222222;width:99%;height:99%;" :src="
                        require(`../../assets/mine/${
                          item.GroupCode == 'MedicinalLincense'
                            ? 'YPxkzbgjl'
                            : item.GroupCode == 'BusinessLincense'
                            ? 'BGyyzz'
                            : 'xiangjiaa'
                        }.png`)
                      " v-else />
                    </iFile>
                  </van-grid-item>

                  <van-grid-item
                    v-if="BaseDatas.LegalIdentifyClientIdentify == 1 ? item.GroupCode == 'LegalIdentify' : BaseDatas.LegalIdentifyClientIdentify == 2 ? item.GroupCode == 'ClientIdentify' :  item.GroupCode == 'LegalIdentify'">
                    <div v-if="item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrValue || !edit" class="relative"
                      :class="edit ? 'bgmoren' : 'bgmorendisabled'">
                      <van-image width="100%" height="110px" lazy-load fit="cover" radius="2" :src="
                        _getPic(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrValue,true)" @click.stop="() =>
                          handleImgPreview(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url' )[0].AttrValue,0)" v-if="item['CustomerAttrDtos'].filter(
                          (tag) => tag.AttrCode == 'Url' )[0].AttrValue" />
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999" v-else />
                      <van-icon name="clear" size="24px" style="position: absolute;top: -12px;right: -12px;" @click.stop="
                        delImage(item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrId)"
                        v-if="FirstOrderStatus != 1 && edit" />
                    </div>
                    <iFile class="i_radius hidden fx justify-content-center" :class="
                      FirstOrderStatus == 1 ? 'bgmorendisabled' : 'bgmoren'" :readonly="FirstOrderStatus == 1 ? true : false" @change="
                      (f) => onFile(f,item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrId)" v-else>
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999"
                        v-if="FirstOrderStatus == 1" />
                      <van-image style="border:1px dashed #222222;width:99%;height:99%;" :src="
                        require(`../../assets/mine/${
                          item.GroupCode == 'MedicinalLincense'
                            ? 'YPxkz'
                            : item.GroupCode == 'BusinessLincense'
                            ? 'YLJGxkz'
                            : item.GroupCode == 'LegalIdentify' ||
                              item.GroupCode == 'ClientIdentify'
                            ? 'SFZbmzp'
                            : item.GroupCode == 'GSP'
                            ? 'GSPzs'
                            : 'xiangjiaa'
                        }.png`)" v-else />
                    </iFile>
                    <div class="ml40">
                      {{item.GroupAttrName}}正面
                    </div>
                  </van-grid-item>

                  <template v-if="BaseDatas.LegalIdentifyClientIdentify == 1 || BaseDatas.LegalIdentifyClientIdentify ==null">
                    <van-grid-item v-if="item['CustomerAttrDtos'].findIndex((tag) => tag.AttrCode == 'LegalIdentifyReverseSide') != -1">
                      <div v-if="item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'LegalIdentifyReverseSide')[0].AttrValue || !edit"
                        class="relative" :class="edit ? 'bgmoren' : 'bgmorendisabled'">
                        <van-image width="100%" height="110px" lazy-load fit="cover" radius="2" :src="
                        _getPic(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'LegalIdentifyReverseSide')[0].AttrValue,true) "
                          @click.stop=" () =>
                          handleImgPreview(item['CustomerAttrDtos'].filter((tag) =>tag.AttrCode == 'LegalIdentifyReverseSide')[0].AttrValue,0) "
                          v-if=" item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'LegalIdentifyReverseSide')[0].AttrValue " />
                        <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999" v-else />
                        <van-icon name="clear" size="24px" style="position: absolute;top: -12px;right: -12px;"
                          v-if="FirstOrderStatus != 1 && edit"
                          @click.stop="
                        delImage(item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'LegalIdentifyReverseSide')[0].AttrId)" />
                      </div>
                      <iFile class="i_radius hidden fx justify-content-center" :class="
                      FirstOrderStatus == 1 ? 'bgmorendisabled' : 'bgmoren'" :readonly="FirstOrderStatus == 1 ? true : false"
                        @change="
                      (f) =>onFile(f,item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'LegalIdentifyReverseSide')[0].AttrId)" v-else>
                        <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999"
                          v-if="FirstOrderStatus == 1" />
                        <van-image style="border:1px dashed #222222;width:99%;height:99%;" :src="require('../../assets/mine/SFZzmzp.png')"
                          v-else />
                      </iFile>
                      <div class="ml40">
                        {{item.GroupAttrName}}反面
                      </div>
                    </van-grid-item>
                  </template>
                  <template v-else-if="BaseDatas.LegalIdentifyClientIdentify == 2">
                    <van-grid-item v-if="item['CustomerAttrDtos'].findIndex((tag) => tag.AttrCode == 'ClientIdentifyReverseSide') != -1">
                      <div v-if="
                      item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'ClientIdentifyReverseSide')[0].AttrValue || !edit "
                        class="relative" :class="edit ? 'bgmoren' : 'bgmorendisabled'">
                        <van-image width="100%" height="110px" lazy-load fit="cover" radius="2"
                          :src="_getPic(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'ClientIdentifyReverseSide')[0].AttrValue,true)"
                          @click.stop="() =>handleImgPreview(item['CustomerAttrDtos'].filter((tag) =>tag.AttrCode == 'ClientIdentifyReverseSide')[0].AttrValue,
                            0 )"
                          v-if="item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'ClientIdentifyReverseSide' )[0].AttrValue" />
                        <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999" v-else />
                        <van-icon name="clear" size="24px" style="position: absolute;top: -12px;right: -12px;"
                          v-if="FirstOrderStatus != 1 && edit"
                          @click.stop="
                        delImage(item.GroupAttrId,item['CustomerAttrDtos'].filter( (tag) => tag.AttrCode == 'ClientIdentifyReverseSide')[0].AttrId )" />
                      </div>
                      <iFile class="i_radius hidden fx justify-content-center" :class="
                      FirstOrderStatus == 1 ? 'bgmorendisabled' : 'bgmoren'" :readonly="FirstOrderStatus == 1 ? true : false"
                        @change=" (f) =>onFile( f,item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'ClientIdentifyReverseSide')[0].AttrId) "
                        v-else>
                        <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999"
                          v-if="FirstOrderStatus == 1" />
                        <!-- <van-icon :name="require('../../assets/mine/xiangjiaa.png')" size="40px" color="#999" v-else /> -->
                        <van-image style="border:1px dashed #222222;width:99%;height:99%;" :src="require('../../assets/mine/SFZzmzp.png')"
                          v-else />
                      </iFile>
                      <div class="ml40">
                        {{item.GroupAttrName}}反面
                      </div>
                    </van-grid-item>
                  </template>
                  <van-grid-item v-if="BaseDatas.LegalIdentifyClientIdentify == 2 && item.GroupCode == 'AuthorityPurchase'">
                    <div v-if="item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrValue || !edit" class="relative"
                      :class="edit ? 'bgmoren' : 'bgmorendisabled'">
                      <van-image width="100%" height="110px" lazy-load fit="cover" radius="2" :src="
                        _getPic(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrValue,true)" @click.stop="() =>
                          handleImgPreview(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url' )[0].AttrValue,0)" v-if="item['CustomerAttrDtos'].filter(
                          (tag) => tag.AttrCode == 'Url' )[0].AttrValue" />
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999" v-else />
                      <van-icon name="clear" size="24px" style="position: absolute;top: -12px;right: -12px;" @click.stop="
                        delImage(item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrId)"
                        v-if="FirstOrderStatus != 1 && edit" />
                    </div>
                    <iFile class="i_radius hidden fx justify-content-center" :class="
                      FirstOrderStatus == 1 ? 'bgmorendisabled' : 'bgmoren'" :readonly="FirstOrderStatus == 1 ? true : false" @change="
                      (f) => onFile(f,item.GroupAttrId,item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Url')[0].AttrId)" v-else>
                      <van-icon :name="require('../../assets/mine/xiangjiaahui.png')" size="40px" color="#999"
                        v-if="FirstOrderStatus == 1" />
                      <van-image style="border:1px dashed #222222;width:99%;height:99%;" :src="
                        require(`../../assets/mine/${
                          item.GroupCode == 'MedicinalLincense'
                            ? 'YPxkz'
                            : item.GroupCode == 'BusinessLincense'
                            ? 'YLJGxkz'
                            : item.GroupCode == 'LegalIdentify' ||
                              item.GroupCode == 'ClientIdentify'
                            ? 'SFZbmzp'
                            : item.GroupCode == 'GSP'
                            ? 'GSPzs'
                            : 'xiangjiaa'
                        }.png`)" v-else />
                    </iFile>
                    <div @click.stop="downloadMb" class="ml40">
                      <van-icon :name="require('../../assets/mine/xiazai-icon.png')" size="0.22rem" />
                      <span class="f10 c0F6EEA cpointer">下载委托书模版</span>
                    </div>
                  </van-grid-item>
                </van-grid>
                <!----------------------------------------------- 证件信息 end --------------------------------------------->

                <!----------------------------------------------- 证件属性 begin --------------------------------------------->
                <template v-if="!edit">
                  <van-cell title="证件号" title-class="text-left c222 f16 w78 flex-n"
                    :value="
                    item['CustomerAttrDtos'].findIndex((tag) => tag.AttrCode == 'Date') != -1? item['CustomerAttrDtos'].filter( (tag) => tag.AttrCode == 'Code' )[0].AttrValue : ''" center
                    value-class="f16 c999 text-left flex3" class="pl0 pr0 pt10 pb15 border-b" v-if=" item['CustomerAttrDtos'].findIndex( (tag) => tag.AttrCode == 'Date'
                    ) != -1 &&item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Code')[0].AttrValue" />
                  <van-cell :border="false" title="有效期" title-class="text-left c222 f16 w78 flex-n" center :value-class="
                    item.QualificationsExpired || item.QualificationsWarning
                      ? 'f16 text-left flex3 cFF3939': 'f16 c999 text-left flex3'" class="pl0 pr0 pt15"
                    v-if=" item['CustomerAttrDtos'].findIndex((tag) => tag.AttrCode == 'Date' ) != -1 && item['CustomerAttrDtos'].filter( (tag) => tag.AttrCode == 'Date')[0].AttrValue ">
                    <template>
                      <div>
                        {{
                        item['CustomerAttrDtos'].findIndex( (tag) => tag.AttrCode == 'Date') != -1
                          ? setDate(item['CustomerAttrDtos'].filter((tag) => tag.AttrCode == 'Date')[0].AttrValue)
                          : ''}}
                        <span>{{
                        item.QualificationsExpired
                          ? '（已过期）'
                          : item.QualificationsWarning
                          ? '（即将过期）'
                          : ''
                      }}</span>
                      </div>
                    </template>
                  </van-cell>
                </template>
                <template v-else>
                  <van-cell title="二证合一" title-class="text-left c222 f16 w78 flex-n" center v-if="item.GroupCode == 'MedicinalLincense'"
                    value-class="f16 c999 text-left flex3" class="pl0 pr0 pt10 pb15 border-b">
                    <template>
                      <van-radio-group v-model="BaseDatas.IsTwoInOne" direction="horizontal" icon-size="14px">
                        <van-radio :name="true">是</van-radio>
                        <van-radio :name="false">否</van-radio>
                      </van-radio-group>
                    </template>
                  </van-cell>
                  <van-field label="证件号" label-class="text-left c222 f16 w78 flex-n" placeholder="统一社会信用代码（区分字母大小写）" :value="
                    item['CustomerAttrDtos'].findIndex(
                      (tag) => tag.AttrCode == 'Date'
                    ) != -1
                      ? item['CustomerAttrDtos'].filter(
                          (tag) => tag.AttrCode == 'Code'
                        )[0].AttrValue
                      : ''
                  " center value-class="f16 c999 text-left flex3" class="pl0 pr0 pt10 pb15 border-b" v-if="
                    item['CustomerAttrDtos'].findIndex(
                      (tag) => tag.AttrCode == 'Date'
                    ) != -1 &&
                      item['CustomerAttrDtos'].filter(
                        (tag) => tag.AttrCode == 'Code'
                      )[0].AttrValue
                  " />
                  <van-cell :border="false" title="有效期" title-class="text-left c222 f16 w78 flex-n" center :value-class="
                    item.QualificationsExpired || item.QualificationsWarning
                      ? 'f16 text-left flex3 cFF3939'
                      : 'f16 c999 text-left flex3'
                  " class="pl0 pr0 pt15" v-if="
                    item['CustomerAttrDtos'].findIndex(
                      (tag) => tag.AttrCode == 'Date'
                    ) != -1 &&
                      item['CustomerAttrDtos'].filter(
                        (tag) => tag.AttrCode == 'Date'
                      )[0].AttrValue
                  ">
                    <template>
                      <div class="fx">
                        <a-date-picker :value="
                          item['CustomerAttrDtos'].findIndex(
                            (tag) => tag.AttrCode == 'Date'
                          ) != -1
                            ? setDate(
                                item['CustomerAttrDtos'].filter(
                                  (tag) => tag.AttrCode == 'Date'
                                )[0].AttrValue
                              )
                            : ''
                        " format="YYYY-MM-DD" :placeholder="'请选择有效期'" allowClear style="width:200px;margin-right:10px"
                          :disabled="checkedBoxState[item.GroupCode]" />
                        <van-checkbox v-model="checkedBoxState[item.GroupCode]" @change="(val) => onCheckChanged(item, val)"
                          icon-size="14px">长期
                        </van-checkbox>
                      </div>
                    </template>
                  </van-cell>
                </template>
                <!----------------------------------------------- 证件属性 end --------------------------------------------->
              </div>
            </template>
          </van-form>
        </div>
        <van-button color="#0F6EEA" text="提交" @click.stop="onSubmit" v-if="edit" class="submitBtn f16 fw600 mt10 mb20" :loading="btn">
        </van-button>
        <!-- 预览图片 -->
        <van-image-preview v-model="preview.show" :images="preview.images" @change="onChangePreview" closeable
          :startPosition="preview.index" />
      </div>
    </template>
  </iMineTemplate>
</template>
<script>
  import { BaseMixin } from '../../mixins/BaseMixin.js'
  import CityAreasControl from '@/components/CityAreasControl.vue'
  import iFile from '@/components/uploader.vue'
  import moment from 'moment'
  export default {
    name: 'MyQualifications',
    mixins: [BaseMixin],
    components: {
      iFile,
      CityAreasControl,
    },
    data() {
      return {
        pageTitle: ['我的账户', '门店资质'],
        activedParentKey: 1,
        activedKey: 13,
        edit: false,
        CustomerType: null,
        CustomerName: null,
        CustomerId: null,
        loading: false,
        FileDatas: [],
        FirstOrderStatus: null,
        FirstOrderStatusReason: null,
        ScopeList: [],
        ygq: [],
        jjgq: [],
        CustomerEmployee: null,
        CustomerIndex: null,
        isFixed: false,
        btn: false,
        preview: {
          show: false,
          index: 0,
          images: [],
        },
        //基础信息
        BaseDatas: {
          IsTwoInOne: null,
          LegalIdentifyClientIdentify: null
        },
        checkedBoxState: {
          //营业执照
          BusinessLincense: false,
          //医疗机构许可证
          OrganLincense: false,
          //药品经营许可证
          MedicinalLincense: false,
        },
      }
    },
    created() {
      this.CustomerType = this.auth.getCustomerType()
      this.CustomerName = this.auth.getCustomerName()
      this.CustomerId = this.auth.getCustomerId()
      this.BaseDatas = this.auth.getCustomerInfo()
    },
    async mounted() {
      await this.getMyQualification()
      this.loading = true
    },
    methods: {
      moment,
      handleImgPreview(img, index) {
        this.preview.images = []
        if (img) {
          this.preview.images.push(img)
          this.preview.show = true
          this.preview.index = index
        }
      },
      setDate(valueTime) {
        if (valueTime) {
          var newDate = new Date(valueTime),
            y1 = newDate.getFullYear(),
            m1 = newDate.getMonth() + 1,
            d1 = newDate.getDate()
          return (
            y1 + '-' + (m1 < 10 ? '0' + m1 : m1) + '-' + (d1 < 10 ? '0' + d1 : d1)
          )
        }
        return ''
      },
      // 图片预览切换
      onChangePreview(index) {
        this.preview.index = index
      },
      //删除图片
      delImage(v, h) {
        let cur = this.FileDatas.findIndex((tag) => tag.GroupAttrId == v)
        let cre = this.FileDatas[cur].CustomerAttrDtos.findIndex(
          (tag) => tag.AttrId == h
        )
        this.FileDatas[cur].CustomerAttrDtos[cre].AttrValue = null
      },
      onFile(file, v, h) {
        let cur = this.FileDatas.findIndex((tag) => tag.GroupAttrId == v)
        let cre = this.FileDatas[cur].CustomerAttrDtos.findIndex(
          (tag) => tag.AttrId == h
        )
        this.FileDatas[cur].CustomerAttrDtos[cre].AttrValue = file
      },
      // 下载委托书模板
      downloadMb() {
        let url = 'https://yyyupdate.oss-cn-shanghai.aliyuncs.com/Template/wts.doc'
        window.location.href = url
      },
      // 提交
      async onSubmit() {
        this.btn = true
        if (this.BaseDatas.IsTwoInOne == null) {
          this.$toast({ position: 'bottom', message: '请选择是否二证合一' })
          this.btn = false
          return
        }
        if (this.CustomerType == 2 && this.FileDatas.BusinessNature == null) {
          this.$toast({ position: 'bottom', message: '请选择营业性质' })
          this.btn = false
          return
        }
        // console.log(this.FileDatas);
        let BusinessLincense = this.FileDatas.filter(
          (item) => item.GroupCode == 'BusinessLincense'
        )
        if (
          this.CustomerType == 1 &&
          BusinessLincense.length &&
          !BusinessLincense[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({ position: 'bottom', message: '请上传营业执照' })
          this.btn = false
          return false
        }
        let LegalIdentify = this.FileDatas.filter(
          (item) => item.GroupCode == 'LegalIdentify'
        )
        let ClientIdentify = this.FileDatas.filter(
          (item) => item.GroupCode == 'ClientIdentify'
        )
        if (
          LegalIdentify.length &&
          LegalIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue &&
          !LegalIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'LegalIdentifyReverseSide'
          )[0].AttrValue
        ) {
          this.$toast({
            position: 'bottom',
            message: '请上传法人代表身份证反面',
          })
          this.btn = false
          return false
        }
        if (
          LegalIdentify.length &&
          LegalIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'LegalIdentifyReverseSide'
          )[0].AttrValue &&
          !LegalIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({
            position: 'bottom',
            message: '请上传法人代表身份证正面',
          })
          this.btn = false
          return false
        }
        if (
          ClientIdentify.length &&
          ClientIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue &&
          !ClientIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'ClientIdentifyReverseSide'
          )[0].AttrValue
        ) {
          this.$toast({ position: 'bottom', message: '请上传委托人身份证反面' })
          this.btn = false
          return false
        }
        if (
          ClientIdentify.length &&
          ClientIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'ClientIdentifyReverseSide'
          )[0].AttrValue &&
          !ClientIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({ position: 'bottom', message: '请上传委托人身份证正面' })
          this.btn = false
          return false
        }

        if (
          LegalIdentify.length &&
          !LegalIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue &&
          ClientIdentify.length &&
          !ClientIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({
            position: 'bottom',
            message: '请上传法人代表身份证或委托人身份证',
          })
          this.btn = false
          return false
        }

        let AuthorityPurchase = this.FileDatas.filter(
          (item) => item.GroupCode == 'AuthorityPurchase'
        )
        if (
          ClientIdentify.length &&
          ClientIdentify[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue &&
          AuthorityPurchase.length &&
          !AuthorityPurchase[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({ position: 'bottom', message: '请上传法人委托书' })
          this.btn = false
          return false
        }
        let MedicinalLincense = this.FileDatas.filter(
          (item) => item.GroupCode == 'MedicinalLincense'
        )
        if (
          this.CustomerType == 1 &&
          MedicinalLincense.length &&
          !MedicinalLincense[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({ position: 'bottom', message: '请上传药品经营许可证' })
          this.btn = false
          return false
        }
        let GSP = this.FileDatas.filter(
          (item) => item.GroupCode == 'GSP'
        )
        if (
          this.CustomerType == 1 && this.BaseDatas.IsTwoInOne == false && GSP.length &&
          !GSP[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({ position: 'bottom', message: '请上传GSP药品经营质量管理规范认证证书' })
          this.btn = false
          return false
        }

        let OrganLincense = this.FileDatas.filter(
          (item) => item.GroupCode == 'OrganLincense'
        )
        if (
          this.CustomerType == 2 &&
          OrganLincense.length &&
          !OrganLincense[0].CustomerAttrDtos.filter(
            (tag) => tag.AttrCode == 'Url'
          )[0].AttrValue
        ) {
          this.$toast({
            position: 'bottom',
            message: '请上传医疗机构执业许可证',
          })
          this.btn = false
          return false
        }

        let params = []
        this.FileDatas.map((item) => {
          item.CustomerAttrDtos.map((chi) => {
            let tag = {
              // ...chi,
              Id: chi.Id,
              AttrId: chi.AttrId,
              Value: chi.AttrValue,
              GroupAttrId: chi.GroupAttrId,
            }
            params.push(tag)
          })
        })
        let data = {
          CustomerId: this.CustomerId,
          CustomerName: this.CustomerName,
          Address: this.BaseDatas.Address,
          ContactsName: this.BaseDatas.ContactsName,
          AreaId: this.BaseDatas.Receiving.AreaId,
          ReceivingAreaId: this.BaseDatas.Receiving.AreaId,
          ReceivingAreaName: this.BaseDatas.Receiving.AddressName,
          ReceivingAddressName: this.BaseDatas.Receiving.Address,
          ReceivingPhone: this.BaseDatas.Phone,
          IsTwoInOne: this.BaseDatas.IsTwoInOne,
          LegalIdentifyClientIdentify: this.BaseDatas.LegalIdentifyClientIdentify,
          BusinessNature: this.FileDatas.BusinessNature,
          Attrses: params,
        }
        console.log(data)
        this.$hys.openLoading()
        const res = await this.postAction(
          '/api_customers/Customer/UpdateAttrGetCustomerAttrQualification',
          data
        )
        this.$hys.clearLoading()
        if (res.IsSuccess) {
          this.$toast.success('提交成功')
          this.FirstOrderStatus = 1
          this.edit = false
          this.btn = false
        } else {
          this.$toast({ position: 'bottom', message: res.Msg })
          this.btn = false
        }
      },
      // 获取资质信息
      async getMyQualification() {
        this.$hys.openLoading()
        const res = await this.getAction(
          '/api_customers/Customer/GetCustomerAttrQualification'
        )
        this.$hys.clearLoading()
        // console.log("获取资质展示数据", res.Data);
        if (res.IsSuccess && res.Data) {
          this.FirstOrderStatus = res.Data.FirstOrderStatus
          this.FirstOrderStatusReason = res.Data.FirstOrderStatusReason

          if (
            res.Data.CustomerGroupAttrDtos &&
            res.Data.CustomerGroupAttrDtos.length
          ) {
            let LegalIdentifyReverseSide = res.Data.CustomerGroupAttrDtos.filter(
              (tag) => tag.GroupCode == 'LegalIdentifyReverseSide'
            )
            let LAttrDtos = LegalIdentifyReverseSide[0].CustomerAttrDtos.filter(
              (tag) => tag.AttrCode == 'Url'
            )

            let ClientIdentifyReverseSide = res.Data.CustomerGroupAttrDtos.filter(
              (tag) => tag.GroupCode == 'ClientIdentifyReverseSide'
            )
            let CAttrDtos = ClientIdentifyReverseSide[0].CustomerAttrDtos.filter(
              (tag) => tag.AttrCode == 'Url'
            )
            res.Data.CustomerGroupAttrDtos.map((item) => {
              // 法人身份证
              if (item.GroupCode == 'LegalIdentify') {
                item.CustomerAttrDtos.push({
                  AttrCode: LegalIdentifyReverseSide[0].GroupCode,
                  AttrId: LAttrDtos[0].AttrId,
                  AttrName: LAttrDtos[0].AttrName,
                  AttrType: LAttrDtos[0].AttrType,
                  AttrValue: LAttrDtos[0].AttrValue,
                  GroupAttrId: LAttrDtos[0].GroupAttrId,
                  Id: LAttrDtos[0].Id,
                })
                if (LAttrDtos[0].AttrValue) {
                  this.BaseDatas.LegalIdentifyClientIdentify = 1
                }
              } else if (item.GroupCode == 'ClientIdentify') {
                // 委托人身份证
                item.CustomerAttrDtos.push({
                  AttrCode: ClientIdentifyReverseSide[0].GroupCode,
                  AttrId: CAttrDtos[0].AttrId,
                  AttrName: CAttrDtos[0].AttrName,
                  AttrType: CAttrDtos[0].AttrType,
                  AttrValue: CAttrDtos[0].AttrValue,
                  GroupAttrId: CAttrDtos[0].GroupAttrId,
                  Id: CAttrDtos[0].Id,
                })
                if (CAttrDtos[0].AttrValue) {
                  this.BaseDatas.LegalIdentifyClientIdentify = 2
                }
              }
            })
            this.FileDatas = res.Data.CustomerGroupAttrDtos.sort(this.compare)
            // console.log(this.FileDatas);
            console.log(this.BaseDatas);
          }
        } else {
          this.$toast({ position: 'bottom', message: res.Msg })
        }

        this.getScope()
        this.getCustomerReceivingAddress()
      },
      compare(x, y) {
        //排序
        if (
          x.GroupCode == 'OrganLincense' ||
          x.GroupCode == 'MedicinalLincense'
        ) {
          return -1
        } else if (x.GroupCode == 'BusinessLincense') {
          return 1
        } else {
          return 0
        }
      },
      // 获取经营范围
      async getScope() {
        const res = await this.getAction(
          '/api_customers/Customer/GetCustomerBusinessScope'
        )
        if (res.IsSuccess && res.Data) {
          this.ScopeList = res.Data
        } else {
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      },
      //获取收货地址
      async getCustomerReceivingAddress() {
        const res = await this.postAction(
          '/api_customers/Customer/GetCustomerReceivingAddress',
          [this.CustomerId]
        )
        if (res.IsSuccess) {
          if (res.Data && res.Data.length) {
            this.BaseDatas.Receiving = res.Data[0]
          }
        } else {
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      },
      //长期选项变化
      onCheckChanged(item, val) {
        // console.log(item)
        this.FileDatas.filter((data) => data.GroupAttrId == item.GroupAttrId)[0]
        let date = item.CustomerAttrDtos.filter((d) => d.AttrCode == 'Date')[0]
        if (date) {
          if (val) {
            date.AttrValue = moment('2999-12-31')
          } else {
            date.AttrValue = moment()
          }
        }
        this.checkedBoxState[name] = val
      },
      fomatDate(valueTime) {
        if (valueTime) {
          var newDate, currentDate, iDays
          currentDate = new Date(valueTime.replace(/-/g, '/'))
          newDate = new Date()
          iDays = parseInt(Math.abs(newDate - currentDate) / 1000 / 60 / 60 / 24)
          if (newDate - currentDate < 0) {
            return -iDays
          }
          return iDays
        }
      },
      //获取是否可以编辑资质信息
      getCanEdit() {
        return false
      },
      setAreas(option) {
        // console.log(option)
        this.BaseDatas.Receiving.AreaId = option.Id
        this.BaseDatas.Receiving.AddressName = option.FullName
      },
      changeEdit() {
        this.edit =
          this.FirstOrderStatus &&
          this.FirstOrderStatus != 4 &&
          this.FirstOrderStatus != 3 &&
          this.edit ?
          '' :
          this.FirstOrderStatus != 1
        setTimeout(() => {
          this.$refs.cityAreas.setValue(this.BaseDatas.Receiving.AreaId)
        }, 500)
      },
    },
  }
</script>
<style lang="less" scoped>
  .content-box {
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);
  }

  .att_title::before {
    content: '';
    width: 3px;
    height: 14px;
    background: rgba(15, 110, 234, 1);
    border-radius: 1px;
    background-size: cover;
    position: absolute;
    top: 6px;
  }

  .w118 {
    width: 118px;
  }

  .w78 {
    width: 78px;
  }

  .submitBtn {
    width: 133px;
    height: 40px;
  }

  .cFE6120 {
    color: #fe6120;
  }

  .boxshadow {
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);
    margin-bottom: 20px;
  }

  .areas-border {
    border-radius: 2px;
    border: 1px solid rgba(229, 229, 229, 1);
    padding-top: 10px;
    padding-bottom: 0px;
    padding-left: 12px;
    padding-right: 12px;
    position: relative;

    &-required {
      margin-left: 4px;
    }

    &-required::after {
      position: absolute;
      top: 0px;
      left: 8px;
      color: #ee0a24;
      font-size: 14px;
      content: '*';
    }
  }

  .bgFFECEC {
    background: #ffecec;
  }

  /deep/.van-grid-item:first-child {
    padding-right: 10px;
  }

  /deep/.van-grid-item:nth-child(2) {
    padding-left: 10px;
  }

  /deep/.van-grid-item__content {
    padding: 0 0 20px 0;
    align-items: flex-start !important;
  }

  /deep/.van-field.input-bo {
    padding: 0;

    .van-field__label {
      position: absolute;
      top: 10px;
      left: 15px;
      line-height: 20px;
    }

    input {
      border-radius: 2px;
      border: 1px solid rgba(229, 229, 229, 1);
      padding-top: 30px;
      padding-bottom: 10px;
      padding-left: 12px;
      padding-right: 12px;

      &:focus {
        border-radius: 2px;
        border: 3px solid rgba(15, 110, 233, 1);
        padding-top: 26px;
        padding-bottom: 10px;
        padding-left: 12px;
        padding-right: 12px;
      }
    }
  }

  .bgmoren {
    background: rgba(241, 247, 255, 1);
    border-radius: 2px;
    width: 200px;
    height: 110px;
  }

  .bgmorendisabled {
    background: rgba(247, 247, 247, 1);
    border-radius: 2px;
    width: 200px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fiexdbg {
    /deep/.default_nav_bar {
      background-color: rgb(15, 110, 234);
    }
  }

  /deep/.van-goods-action {
    position: absolute;
    background-color: rgb(15, 110, 234);
  }
</style>